import axios from 'axios'
import store from '@/store'
import router from '@/router'
import configUrl from './config'
// const WEBAPI_URL = 'http://192.168.0.191:1234/dxwsoft/mobile/'
const service = axios.create({
  baseURL: configUrl.baseURL,
  // baseURL: WEBAPI_URL,
  timeout: 20000 // request timeout
})
// request interceptor发送请求拦截器
service.interceptors.request.use(config => {
  if (config.keyUrl) {
    config.baseURL = '/api/'
  } else {
    config.baseURL = '/dxwsoft/'
  }
  if (config.requestUrlKey) {
    config.baseURL = '/mobile/'
  }
  // do something before request is sent
  if (store.getters.token) {
    config.headers.common['Authorization'] = 'Bearer ' + store.getters.token
  }
  if (config.method === null) { config.method = 'GET' }

  if (config.method === 'POST') { config.data = JSON.stringify(config.data) }
  if (config.contenttype) {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  }

  return config
}, error => {
  // do something with request error
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  // Process return value
  response => {
    if (response.status === 200) {
      return response.data
    } else {
      return Promise.reject(new Error(response.message || 'Error'))
    }
  },
  error => {
    console.log(error.response)
    if (error.response.status === 401 || error.response.status === 403) {
      router.replace({ path: './login' })
      return false
    }
    return Promise.reject(error)
  }
)

export default service
